var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { TableRowCell } from "./TableRowCell";
import { IconCloseCircle } from "../../icons";
export var TableRow = function (_a) {
    var data = _a.data, columns = _a.columns, onRowClick = _a.onRowClick, expandable = _a.expandable, onExpand = _a.onExpand, singleExpandable = _a.singleExpandable, rowClassName = _a.rowClassName, withCloseExpandableIcon = _a.withCloseExpandableIcon;
    var tableRowsRef = useRef([]);
    var setTableRowsRef = function (el, itemIndex) {
        tableRowsRef.current[itemIndex] = el;
    };
    // update ref length when data is updated
    useEffect(function () {
        tableRowsRef.current = tableRowsRef.current.slice(0, data.length);
    }, [data]);
    // expand or collapse row
    var toggleExpandHandler = function (itemIndex) {
        var isExpand = !tableRowsRef.current[itemIndex].hidden;
        // collapse all expandable rows
        if (singleExpandable) {
            tableRowsRef.current.forEach(function (el) {
                el.hidden = true;
            });
        }
        tableRowsRef.current[itemIndex].hidden = isExpand;
        if (typeof onExpand === "function")
            onExpand(!isExpand, data[itemIndex]);
    };
    return (_jsx(_Fragment, { children: data.map(function (item, itemIndex) { return (_jsxs(React.Fragment, { children: [_jsx("tr", __assign({ onClick: function () {
                        if (expandable === null || expandable === void 0 ? void 0 : expandable.expand)
                            toggleExpandHandler(itemIndex);
                        if (onRowClick)
                            onRowClick(item);
                    }, className: typeof rowClassName === "function" ? rowClassName(item, itemIndex) : "" }, { children: columns.map(function (column, columnIndex) { return (_jsx(TableRowCell, { item: item, column: column, index: columnIndex, rowIndex: itemIndex }, "mex-table-row-".concat(itemIndex, "-cell-").concat(columnIndex))); }) })), expandable && expandable.expand && (_jsx("tr", __assign({ ref: function (el) { return setTableRowsRef(el, itemIndex); }, className: "mex-table_row-expand", hidden: true }, { children: _jsx("td", __assign({ colSpan: columns.length }, { children: _jsxs("div", { children: [withCloseExpandableIcon && (_jsx("div", __assign({ className: "mex-table-row-expand__header-close-icon" }, { children: _jsx(IconCloseCircle, { onClick: function () {
                                            toggleExpandHandler(itemIndex);
                                        } }) }))), _jsx("div", __assign({ className: "mex-table_row-expand-body" }, { children: _jsx(_Fragment, { children: expandable.content(item) }) }))] }) })) })))] }, "mex-table-row-".concat(itemIndex))); }) }));
};
